import { Button, Collection, Flex, Link as UiLink } from "@aws-amplify/ui-react"
import { formatUnicorn } from "@strtmn/strtmn"
import { I18n } from "aws-amplify/utils"
import { FaPlus } from "react-icons/fa6"
import { Link as ReactRouterLink } from "react-router-dom"
import { FilterAndSort } from "./FilterAndSort"

interface ListPageProps {
  _className: string
  hasAddButton?: boolean
  icon: React.ReactNode
  items: any[]
  maxNumItems?: number
  renderFunc: (item: any, index: number) => React.ReactElement
  title: string
}
export const ListPage = ({
  _className,
  hasAddButton = true,
  icon,
  items,
  maxNumItems,
  renderFunc,
  title,
}: ListPageProps) => {
  let hasTooManyItems = undefined
  let isAddDisabled = false
  if (maxNumItems !== undefined) {
    hasTooManyItems = items.length >= maxNumItems
    isAddDisabled = hasTooManyItems
  }

  return (
    <>
      <div className="rm-list-page">
        <Flex className="!h-12 !pb-2 !justify-between !items-center">
          <Flex className="!h-6 !justify-start !items-center gap-3">
            {icon}
            <div className="text-xl font-semibold">{title}</div>
          </Flex>

          {hasAddButton && (
            <Flex className="!justify-center !items-center gap-2.5">
              <UiLink to="new" as={ReactRouterLink}>
                <Button
                  className="button-add has-icon"
                  isDisabled={isAddDisabled}
                >
                  {hasTooManyItems === true ? (
                    <span
                      title={formatUnicorn(I18n.get(`{numItems} Einträge`), {
                        numItems: items.length,
                      })}
                    >
                      {maxNumItems}
                    </span>
                  ) : (
                    <span role="img" aria-label="add">
                      <FaPlus />
                    </span>
                  )}
                </Button>
              </UiLink>
            </Flex>
          )}
        </Flex>

        <div className="rm-list-container">
          <FilterAndSort />

          <Collection
            type="list"
            items={items}
            className={`rm-list ${_className}`}
          >
            {(item, index) => renderFunc(item, index)}
          </Collection>
        </div>
      </div>
    </>
  )
}
